/**
 * This file will be loaded at the end of the <body> tag
 *
 * NOTE: The code here will NOT be transpilled or have polyfills.
 * Ensure code is IE friendly
 */

/*
 * removing the fabulist link from the Canadian website
 */

if (
  window.location.href.indexOf('aesop.com/ca/en') > 0 &&
  window.location.href.indexOf('readMenu=open') > 0
) {
  document
    .querySelector("[href='/ca/en/r/the-fabulist']")
    .parentNode.removeChild(
      document.querySelector("[href='/ca/en/r/the-fabulist']")
    );
}
if (
  window.location.href.indexOf('aesop.com/ca/fr') > 0 &&
  window.location.href.indexOf('readMenu=open') > 0
) {
  document
    .querySelector("[href='/ca/fr/r/the-fabulist']")
    .parentNode.removeChild(
      document.querySelector("[href='/ca/fr/r/the-fabulist']")
    );
}

// Check if within CA, AU, US, or UK
if (/^\/(ca|au|us|uk)/.test(window.location.pathname)) {
  // console.log('If within country');
}
